/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconLibra: {
  name: 'libra';
  data: string;
} = {
  name: 'libra',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M41.003 455.444h529.799v99.159H41.003v-99.159zm308.916-79.91v-61.008c29.477-16.012 48.921-46.093 48.921-80.629 0-50.591-41.716-91.6-93.155-91.6s-93.149 41.009-93.149 91.6c0 34.122 18.969 63.885 47.111 79.648v61.989l-.366 37.736H40.996v-99.153h79.16c-11.941-24.479-18.597-51.731-18.597-80.44 0-106.424 91.478-192.703 204.327-192.703s204.327 86.279 204.327 192.703c0 28.709-6.656 55.961-18.597 80.44h79.166v99.153h-220.85l-.013-37.736z"/></svg>`,
};
